module.exports = __webpack_public_path__ + "static/order-a2806e7f4ed63708dc7a94b864b67911.png";